import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { authUtilityLoader } from '@consumer/auth-utility-loader';
import { eventBus } from "../../../../eventBus/eventBus"; // e.g. const { getConsumerId, signOut, ...all functions used by this file } = await import(/* webpackIgnore: true */ AUTH_UTILITY_URL);
export var signOut = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
    var _yield$authUtilityLoa, authUtilitySignOut;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return authUtilityLoader();
        case 2:
          _yield$authUtilityLoa = _context.sent;
          authUtilitySignOut = _yield$authUtilityLoa.signOut;
          _context.next = 6;
          return authUtilitySignOut();
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function signOut() {
    return _ref.apply(this, arguments);
  };
}();
export var getConsumerId = function () {
  var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
    var _yield$authUtilityLoa2, authUtilGetConsumerId;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return authUtilityLoader();
        case 2:
          _yield$authUtilityLoa2 = _context2.sent;
          authUtilGetConsumerId = _yield$authUtilityLoa2.getConsumerId;
          _context2.next = 6;
          return authUtilGetConsumerId();
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getConsumerId() {
    return _ref2.apply(this, arguments);
  };
}();
export var getIdToken = function () {
  var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3() {
    var _yield$authUtilityLoa3, getIsUserSignedIn, cognitoIdToken, updatedIsUserSignedIn, token;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return authUtilityLoader();
        case 2:
          _yield$authUtilityLoa3 = _context3.sent;
          getIsUserSignedIn = _yield$authUtilityLoa3.getIsUserSignedIn;
          cognitoIdToken = _yield$authUtilityLoa3.cognitoIdToken;
          _context3.next = 7;
          return getIsUserSignedIn();
        case 7:
          updatedIsUserSignedIn = _context3.sent;
          if (!updatedIsUserSignedIn) {
            _context3.next = 14;
            break;
          }
          _context3.next = 11;
          return cognitoIdToken();
        case 11:
          _context3.t0 = _context3.sent;
          _context3.next = 15;
          break;
        case 14:
          _context3.t0 = '';
        case 15:
          token = _context3.t0;
          return _context3.abrupt("return", token);
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getIdToken() {
    return _ref3.apply(this, arguments);
  };
}();
export var publishFetchProfileData = function publishFetchProfileData() {
  eventBus.publish('userProfile.fetchProfileData');
};